 import { Component, OnInit, AfterViewInit } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { FileLikeObject, FileUploader } from 'ng2-file-upload';
import { AuthService } from 'src/app/API/auth.service';
import { DocumentCategoryService } from 'src/app/API/documentcategory.service';
import { InvApiService } from 'src/app/API/invapi.service';
import { AppComponent } from 'src/app/app.component';
import { ImageViewerDialog } from 'src/app/Core/Shared/ImageViewerDialog/ImageViewerDialog';
import { URLDialog } from 'src/app/Core/Shared/URLDialog/URLDialog';
import { Globals } from 'src/app/globals';

@Component({
  selector: 'DocumentLibrary',
  templateUrl: './DocumentLibrary.component.html',
  styleUrls: ['./DocumentLibrary.component.css']
})
export class DocumentLibraryComponent implements OnInit, AfterViewInit {

  urlDialogRef: MatDialogRef<URLDialog>;
  accordionTabs: any[] = [];

  currentPageNumber = 1;
  sortExpression = 'designationName';
  sortDirection = 'ASC';
  pageSize = 25;

  extension: string;
  public uploadID = 'ng2Fileuploader';
  selectedTab: any = null;
  currentUserId = this.auth.GetUserId();
  allDocuments: any[] = [];     // master list (everything from backend)


  // ================= FILE UPLOADER =================
  public uploader: FileUploader = new FileUploader({
  url: Globals.apiUrl + 'Files/Upload?containerName=document-library',
  autoUpload: true,
  method: 'POST',
  allowedMimeType: [
    'application/pdf',
    'image/png',
    'image/jpg',
    'image/jpeg',
    'image/gif',
    'image/webp'
  ],
    maxFileSize: 20 * 1024 * 1024
  });

  constructor(
    private documentCategoryService: DocumentCategoryService,
    private invapi: InvApiService,
    public dialog: MatDialog,
    private auth: AuthService
  ) { }

  // ================= INIT =================
  ngOnInit() {
    this.getDocumentCategories();
  }

  ngAfterViewInit() {

      this.uploader.onWhenAddingFileFailed = (item, filter) => {
        this.onWhenAddingFileFailed(item, filter);
      };

      this.uploader.onAfterAddingFile = item => {
        item.withCredentials = false;
        AppComponent.ShowLoader();
      };

    this.uploader.onCompleteItem = (item, response) => {

     const json = JSON.parse(response);
       item.index = json.uploadfilename;
      // if (this.selectedTab) {
      //   this.selectedTab.loaded = false;
      //   this.loadDocuments(this.selectedTab.title);
      // }
       if (this.selectedTab) {
          const fileLabel = json.originalfilename.replace(/\.[^/.]+$/, '');

    // ✅ add uploaded file immediately to UI
          // this.selectedTab.documents.unshift({
          //   fileLabel: fileLabel,
          //   fileName: json.uploadfilename,
          //   container: 'document-library',
          //   categoryId: this.selectedTab.id
          // });

          const newDocument = {
              fileLabel: fileLabel,
              fileName: json.fileurl.split('document-library/')[1],
              container: 'document-library',
              categoryId: this.selectedTab.id
            };

          const documentCreate = this.prepareUploadDocument(newDocument);
         this.invapi.UploadDocumentByCategory(documentCreate)
            .subscribe(res => {
              this.loadDocuments();
              AppComponent.HideLoader();   // ✅ hide loader after DB save
            },
            error => {
              AppComponent.HideLoader();
            });

          this.selectedTab.loaded = true;

          console.log('this.selectedTab.documents'+this.selectedTab.documents.length);
        }
    };
      this.uploader.onErrorItem = (item, response, status) => {
        AppComponent.HideLoader();
        AppComponent.addAlert('Upload failed', 'error');
      };
   
  }

  // ================= CATEGORY LOAD =================
  getDocumentCategories() {

    AppComponent.ShowLoader();

    this.documentCategoryService
      .GetDocumentCategoryList(this.prepareSearch())
      .subscribe(res => {

        this.accordionTabs =
          res.documentCategoryDetails.map((x, index) => ({
            id: x.documentCategoryId,
            title: x.documentCategoryName,
            containerCategoryName:x.containerCategoryName,
            documents: [],
            staticDocuments: [],      
            dynamicDocuments: [],     
            collapsed: index !== 0,
            loaded: false
          }));

        // open first tab automatically
        if (this.accordionTabs.length > 0) {
          this.selectedTab = this.accordionTabs[0];
          this.loadDocuments();
        }

        AppComponent.HideLoader();
      },
        error => {
          AppComponent.addAlert(error.message, 'error');
          AppComponent.HideLoader();
        });
  }

  // ================= TAB OPEN =================
  onTabOpen(event: any) {
  this.selectedTab = this.accordionTabs[event.index];
}

  // ================= DOCUMENT LOAD =================

   loadDocuments() {

  AppComponent.ShowLoader();

  this.invapi.GetAllDocuments()
    .subscribe(res => {

      // Store master list
      this.allDocuments = res.map(x => ({
        fileLabel: x.fileLabel,
        fileName: x.fileName,
        container: x.containerName,
        categoryId: x.documentCategoryId,
        isStatic: x.isStatic
      }));

      // Distribute documents to tabs
      this.assignDocumentsToTabs();

      // mark all tabs loaded
      this.accordionTabs.forEach(t => t.loaded = true);

      AppComponent.HideLoader();
    },
    error => {
      AppComponent.addAlert(error.message, 'error');
      AppComponent.HideLoader();
    });
}

  assignDocumentsToTabs() {

  this.accordionTabs.forEach(tab => {

    tab.documents = this.allDocuments.filter(d =>
      d.categoryId === tab.id
    );

    tab.staticDocuments = tab.documents.filter(d => d.isStatic === true);
    tab.dynamicDocuments = tab.documents.filter(d => d.isStatic === false);

    tab.loaded = true;
  });
}

  // ================= PREPARE REQUEST =================
  // prepareCreateViewModel(value: string) {

  //   const val = value
  //     .toLowerCase()
  //     .trim()
  //     .replace(/[^a-z0-9\s]/g, '')
  //     .replace(/\s+/g, '_');

  //   return {
  //     containerCategoryName: val,
  //   };
  // }

  prepareSearch() {
    return {
      currentPageNumber: this.currentPageNumber,
      sortExpression: this.sortExpression,
      sortDirection: this.sortDirection,
      pageSize: this.pageSize
    };
  }
prepareUploadDocument(newDocument: any) {

  const uploadDocumentCreate: any = {};
  uploadDocumentCreate.DocumentCategoryId = newDocument.categoryId;
  uploadDocumentCreate.isStatic = 0;
  uploadDocumentCreate.containerCategoryName = this.selectedTab.containerCategoryName;
  uploadDocumentCreate.DocumentLibraryDetails = [];
  uploadDocumentCreate.DocumentLibraryDetails.push({
    fileLabel: newDocument.fileLabel,
    fileName: newDocument.fileName,
    createdBy: this.currentUserId,
    documentCategoryId: newDocument.categoryId,
    isStatic: 0
  });
  return uploadDocumentCreate;
}

  // ================= UPLOAD =================
  UploadFiles(tab: any) {
    this.selectedTab = tab;

    const category = tab.containerCategoryName;

    this.uploader.setOptions({
      url: `${Globals.apiUrl}Files/Upload?containerName=document-library&category=${encodeURIComponent(category)}`
    });
  
    document.getElementById(this.uploadID + '_' + tab.id)?.click();
  }

  // ================= OPEN DOCUMENT =================
  openImageDialog(container: string, fileName: string, fileLabel: string) {

    this.invapi.GetSasUrl(container, fileName).subscribe(response => {

      const sasUrl = response.url;
      this.extension = fileName.split('.').pop()?.toLowerCase();

      if (['png', 'jpg', 'jpeg', 'gif'].includes(this.extension)) {

        this.dialog.open(ImageViewerDialog, {
          position: { right: '0', top: '0' },
          height: '100%',
          width: '70%',
          data: { imgURL: sasUrl, title: fileLabel }
        });

      } else {

        this.urlDialogRef = this.dialog.open(URLDialog, {
          disableClose: true,
          position: { right: '0', top: '0' },
          height: '100%',
          width: '80%',
        });

        this.urlDialogRef.componentInstance.URL = sasUrl;
        this.urlDialogRef.componentInstance.PageTitle = fileLabel;
      }

    });
  }

  // ================= ERROR =================
  onWhenAddingFileFailed(item: FileLikeObject, filter: any) {

    let errorMessage;

    switch (filter.name) {
        case 'fileSize':
            errorMessage = `Maximum upload size exceeded (${Math.round((item.size/1024/1024))} MB of 20 MB allowed)`;
            break;
        case 'mimeType':
            errorMessage = `Type '${item.type} is not allowed. Allowed types: '(JPG, GIF, PNG, DOC, XLS, PPT, PDF, JPEG)'`;
            break;
        default:
            errorMessage = `Type '${item.type} is not allowed. Allowed types: '(JPG, GIF, PNG, DOC, XLS, PPT, PDF, JPEG)'`;
    }

    AppComponent.addAlert(errorMessage, 'error');
  }

  setCategorywithFileName(fileName: string): string {
    return  fileName;
  }

 getFileIcon(fileName: string): { icon: string, class: string } {

  if (!fileName) return { icon: 'fa-file-o', class: 'default-icon' };

  const ext = fileName.split('.').pop()?.toLowerCase();

  switch (ext) {
    case 'png':
    case 'jpg':
    case 'jpeg':
    case 'gif':
    case 'webp':
      return { icon: 'fa-file-image-o', class: 'image-icon' };

    case 'pdf':
      return { icon: 'fa-file-pdf-o', class: 'pdf-icon' };

    case 'doc':
    case 'docx':
      return { icon: 'fa-file-word-o', class: 'word-icon' };

    case 'xls':
    case 'xlsx':
      return { icon: 'fa-file-excel-o', class: 'excel-icon' };

    case 'ppt':
    case 'pptx':
      return { icon: 'fa-file-powerpoint-o', class: 'ppt-icon' };

    default:
      return { icon: 'fa-file-o', class: 'default-icon' };
  }
}
}
